module.exports = __webpack_public_path__ + "static/media/img_Inscription_free2@2x.5d382baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Inscription_free2@2x.png
// module id = 985
// module chunks = 0